import React, { useState , useEffect, useContext, useRef} from 'react';
import Logo from '../images/logo.png';
import '../css/pair.css'



import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faInfo, faDashboard, faBookBookmark, faCalendar,
     faPuzzlePiece , faShieldAlt, faDiceOne, faBahtSign, faChartBar, faTools
    , faBell, faChevronDown, faArrowUp,
    faUser,
    faGift,
    faMessage,
    faUserAlt,
    faCheck} from '@fortawesome/free-solid-svg-icons';

import { Link, useNavigate } from 'react-router-dom'
import { ShareContext } from '../context/sharecontext';
import * as Constants from '../constants';
import LoadingImg from '../images/loading.gif';
import GCustomerHeader from '../partials/gCustomerHeader';


function Pair() {
    const { profile, token, activepair, setActivePair } = useContext(ShareContext);
    const navigate = useNavigate();
    const [staySigned, setStaySigned] = useState(false)
    //load profile info.
    const [user, setUser] =useState({});
    const [loading, setLoading] =useState(false);
    const [cards, setCards]=useState([]);
    const [used, setUsed]= useState(0);
    const [unUsed,setUnUsed]=useState(10);
    const [pairB, setPairB]= useState({});
    const [turnBy, setTurnBy] =useState('');
    const [firstcall, setFirstCall]=useState(true);
    const [notePick,setNotePick] =useState('');
    const [winnerId, setWinner]=useState(null);
    const [sec, setSec] =useState(120);
    var _sec=60;
    const count = useRef();
    //const exacttime=1000

    const colorA='#13B7FD';
    const colorB='#36981D';
    const color0="black";
    const callduration=2000;
    
    var intervalid=null;
    const onTimer=()=>{
        
        const myTimeout = setTimeout(Load, callduration);
    }

    const onExpireTime=()=>{ //for the up 
      
        setSec(count.current);
       count.current = count.current -1;
        console.log(`prev ${count.current} new `)
        if(count.current>0 ){ //&& activepair.winnerId==null
            setTimeout(onExpireTime,1000);
        }
        
     }

    /*  useEffect(() => {
        onExpireTime();
       //for timer
     console.log('moment sec execute on *********************');
          }, [sec]); */


    useEffect(() => {
     
      setSec(120);
      count.current=120;
       //LoadReports();
        var c=[];
        for (let index = 0; index < 10; index++) {
            const cc={id:index+1,pickerid:0,score:0};
            c.push(cc);
        }
        setCards(c);
       onExpireTime();
      // setSec(119); //fist call
       console.log('********************first call for sec')
    
         }, []);

         useEffect(() => {

           if(winnerId!=null){
            //ended
             setTimeout(onWinner,20000); //wait for 20 second
           }

         }, [winnerId]);


         useEffect(() => {
     
           if(cards.length>0 && firstcall){
            console.log('call from firstcall and card has value');
            if((activepair.pairB.id==profile?.id && activepair.turnBy=="B") || (activepair.pairA.id==profile?.id && activepair.turnBy=="A")){
                console.log('do not need to start a timer' );
             }else{
                 //intervalid = setInterval(Load, callduration);
                 console.log('starting timer........ its your oponent turn' );
                    onTimer();
              }
     
             Load();
           }
     
             
            
             return () => clearInterval(intervalid);
              }, [cards]);


    useEffect(() => {
     
     
     //  console.log('content of cards before update')
       //     console.log(cards);
            if(cards.length> 0){
                console.log('notepick '+notePick);
                const pairs =notePick==null?[]: notePick?.split(';');
            const returncards=[];
           // console.log('content of cards before update')
          //  console.log(cards);
            var _cards=[...cards];
          //  console.log(_cards);
                // Loop through each pair and construct the object
                for (let i = 0; i < pairs.length; i++) {
                    // Ignore empty strings (like the last split)
                    if (pairs[i] !== '') {
                        // Split each pair by colon to get key and value
                        //id:cardindex+1,pickerid:profile.id,score: data.num
                        const [id, score,pickerid] = pairs[i].split(':');
                        _cards[parseInt(id)-1]={id,pickerid,score};
                        // Add an object with key and value to the array
                        returncards.push({ id, score,pickerid });
                    }
                }
                setUsed(returncards.length);
                setUnUsed(cards.length-returncards.length);
                setCards(_cards);
             //   console.log('content of cards after update')
              //  console.log(_cards);
            }
            
           if ((activepair.pairA.id==profile?.id && turnBy=="B") || (activepair.pairB.id==profile?.id && turnBy=="A")){
            console.log('starting a timer************************* on turnby');
            onTimer();
           }else{
            console.log('stoping a timer*****************************, ignore the call');
            //clearInterval(intervalid);
           }

      
      
     

         }, [turnBy, firstcall]);

    const Load=async()=>{
      
        var urls=`${Constants.rooturl}/game/checkturn/${activepair.id}`;
        try {
           // setLoading(true);
            const resp = await fetch(urls, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': token,
                
              },
            });
            
            const data = await resp.json();
          
           // setLoading(false);
            console.log(data);
            if (data.code === 0) {
                //reconstruct the list
                //code = 0,pair.TurnBy, pair.WinnerId, pair.PickNote
                if(firstcall || turnBy!=data.turnBy){ //only update if what you have is different
                   
                    setTurnBy(data.turnBy);
                    setNotePick(data.pickNote);
                    setActivePair({...activepair, pairBscore:data.pairBscore,pairAscore:data.pairAscore});
                    setWinner(data.winnerId);
                }else{
                    console.log('calling timer again in Load');
                    onTimer();
                }
                
                setFirstCall(false); //that way second option is called
                
            }else {    
              console.error(data.status);
            }
          } catch (error) {
            setLoading(false);
            console.error(error); 
          }
     }

     const LoadReports=async()=>{
      
      var urls=`${Constants.rooturl}/customer/activities/${profile.id}`;
      try {
          setLoading(true);
          const resp = await fetch(urls, { 
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': token,
              
            },
          });
          
          const data = await resp.json();
        
          setLoading(false);
          console.log(data);
          if (data.code === 0) {
              
              
          }else {    
            console.error(data.status);
          }
        } catch (error) {
          setLoading(false);
          console.error(error); 
        }
   }

   const onPick=async(cardindex)=>{
    
    if(cards[cardindex].pickerid>0){
        //card already picked
        console.log('card already picked, pick another');
        return;
    }
      setLoading(true);
      const totalPicked =used+1  ;//cards.filter(obj => obj.score > 0).length;
      try {
        var v={Pickno:(cardindex+1), lastcard:false,Turn:turnBy, totalPicked:(totalPicked)}; //+1 include the present one about to call
        const resp = await fetch(`${Constants.rooturl}/game/pick/${activepair.id}`, {
          method: 'POST',
          body:JSON.stringify(v) ,
          headers: {
            'Content-Type': 'application/json, text/plain',
            'Authorization': token,
          },
        });
        
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
           //get //code = 0, num, pair.WinnerId, pair.TurnBy
           setTurnBy(data.turnBy);
           //update the value in //id:index+1,pickerid:0,score:0
           var _cards=[...cards];
           _cards[cardindex]={id:cardindex+1,pickerid:profile.id,score: data.num};
           setCards(_cards);
           setUsed(used+1);
            setUnUsed(unUsed-1);
           //Load();
          //  intervalid = setInterval(Load, callduration);
          setActivePair({...activepair, pairBscore:data.pairBscore,pairAscore:data.pairAscore})
          setWinner(data.winnerId);
            onTimer();// so it can start calling

        } 
      } catch (error) {
        setLoading(false);
        console.error(error);
       // setErr(Constants.serverErr);
       // onMove();
      }

     }

  const onWinner=()=>{
        setActivePair({...activepair, winnerId});
        navigate('/customer/game/win');
  }   

  return (
 
    <div>
      {loading && <div>
        <img src={LoadingImg} style={{width:300, marginLeft:'auto', marginRight:'auto'}} />
        </div>}  
    
        <div className='homebar'>
        
        <div className='logoside'>
          <img src={Logo}/> 
          <span>TWO LEAVES GAMES</span>
        </div>
        <div style={{display:'flex'}}>
            <div class='timeIndicator'><p>
                <span>Time</span><span>{Constants.timestr(sec)} </span>
            </p>
                
            </div>
        </div>
        <div className='menu'>
          <ul>
            
            <li ><Link to="/"><FontAwesomeIcon icon={faMessage}  /></Link></li>
            <li ><Link to="/"><FontAwesomeIcon icon={faUser}  /></Link></li>
            
          </ul>
        </div>
      </div>
<div className='cusBody'> 
    
    
    <div className='pairback'>
       <div className='pairmember'>
            <div>
                <div className='avatar'>
                    <FontAwesomeIcon icon={faUserAlt} style={{fontSize:40, color:colorA}}  />
                </div>
            
            <p className='playername'>{activepair.pairA.id==profile?.id?'You':activepair.pairA.firstname}</p>
            <div>
                <span className='playerphone'>{activepair.pairA.phone}</span><br/>
                <span className='playersocre'>Score: {activepair.pairAscore}</span>
            </div>
           {turnBy=='A' && <p className='turn'>Turn A</p>} 
            </div>
            <div className='playermiddle'>
            <p><span>Used Card:</span><span>{used}</span></p>
            <p><span>Unused Card:</span><span>{unUsed}</span></p>
            {winnerId!=null && <h2 className='splashanim'>Game Over!</h2>}
        </div>
        <div>
                <div className='avatar'>
                    <FontAwesomeIcon icon={faUserAlt} style={{fontSize:40, color:colorB}}  />
                </div>
            
                <p className='playername'>{activepair.pairB.id==profile?.id?'You':activepair.pairB.firstname}</p>
            <div>
                <span className='playerphone'>{activepair.pairB.phone}</span><br/>
                <span className='playersocre'>Score: {activepair.pairBscore}</span>
            </div>
           {turnBy=='B' && <p className='turn'> Turn B</p>} 
            </div>
       </div>
        

       <div className='cards'>
       {cards?.map((card, idx) =>{return (
                    <div className='card' key={idx} style={{backgroundColor:(card.pickerid==activepair.pairA.id? colorA:(card.pickerid==activepair.pairB.id? colorB:color0))}} onClick={()=>onPick(idx)}>
                       <div className='cardtop'>
                        <span>Card: {idx+1} </span>
                        {card.pickerid>0 && <FontAwesomeIcon icon={faCheck}  />}
                        </div> 
                        {card.pickerid>0 &&  <div className='cardpick'>
                            <span>{card.score}</span>
                        </div>}
                       
                        

                    </div>
                  )})}
       </div>

    </div>
    </div>
         
    </div>

  )
}

export default Pair